module.exports = __webpack_public_path__ + "static/media/back.3a23fe19.svg";